import React, { useEffect, useState } from "react";

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

const getRemaining = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff % 86400000) / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000),
  };
};

const Countdown = ({ target, compact = false }) => {
  const [t, setT] = useState(getRemaining(target));

  useEffect(() => {
    const iv = setInterval(() => setT(getRemaining(target)), 1000);
    return () => clearInterval(iv);
  }, [target]);

  const units = [
    { v: t.d, l: "DAYS" },
    { v: t.h, l: "HRS" },
    { v: t.m, l: "MIN" },
    { v: t.s, l: "SEC" },
  ];

  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="countdown">
      {units.map((u, i) => (
        <React.Fragment key={u.l}>
          <div
            className={`flex flex-col items-center justify-center border border-[#22304e] bg-[#0c1428]/80 ${
              compact ? "w-14 h-14" : "w-16 h-16 sm:w-20 sm:h-20"
            }`}
          >
            <span className={`font-heading text-white leading-none ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
              {pad(u.v)}
            </span>
            <span className="font-mono text-[8px] tracking-[0.3em] text-[#6f7d9f] mt-1">{u.l}</span>
          </div>
          {i < 3 && <span className="text-[#3f639f] font-heading text-xl sm:text-2xl">:</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Countdown;
